import { useForm } from 'react-hook-form';
import { useZipcode } from './useZipcodeQuery';
import { useOptions } from './useOptions';
import { useSelector } from 'react-redux';
import { useEffect } from 'preact/hooks';
import { handleSubmitForm } from '../function/submitHandler';
import { onUploadFile } from './onUploadFile';

export const useGetClaimList = () => {
  const { control, getValues, setValue, watch, reset, handleSubmit } = useForm({
    defaultValues: {
      warrantyMobileIds: [],
      warrantyMobileOtherReason: '',
    },
  });
  const { mutate: onCallZipCode, loading: isLoadingZipCode } = useZipcode({ reset, getValues });

  const { provinceOptions, districtOptions, subDistrictOptions } = useOptions({ watch, setValue });
  const { mutate: onAddClaim, loading: isLoadingToSave } = onUploadFile();
  const isCreateNewAddress = watch('isCreateNewAddress');
  const warrantyData = useSelector((state) => state.warrantyData.data);
  const storedWarrantyData = localStorage.getItem('warrantyData');
  const parsedData =
    warrantyData ||
    (() => {
      try {
        return storedWarrantyData ? JSON.parse(storedWarrantyData) : {};
      } catch {
        return {};
      }
    })();
  useEffect(() => {
    if (warrantyData) {
      localStorage.setItem('warrantyData', JSON.stringify(warrantyData));
    }
  }, [warrantyData]);

  const addressData = parsedData?.addresses;
  useEffect(() => {
    if (!addressData || addressData.length === 0) {
      setValue('isCreateNewAddress', 'true');
    }
  }, [addressData, setValue]);

  const onChangeAddress = (value) => {
    const addressSetNew = addressData?.find((item) => item?.customerAddressId === value);
    if (addressSetNew) {
      setValue('zipcode', addressSetNew?.zipcode);
      setValue('provinceId', {
        value: addressSetNew?.provinceId,
        label: addressSetNew?.provinceName,
      });
      setValue('districtId', {
        value: addressSetNew?.districtId,
        label: addressSetNew?.districtName,
      });
      setValue('subDistrictId', {
        value: addressSetNew?.subDistrictId,
        label: addressSetNew?.subDistrictName,
      });
      setValue('other', addressSetNew?.other);
    }
  };
  useEffect(() => {
    if (isCreateNewAddress === 'true') {
      setValue('customerAddressId', null);
      setValue('zipcode', '');
      setValue('provinceId', null);
      setValue('districtId', null);
      setValue('subDistrictId', null);
      setValue('other', '');
    }
  }, [isCreateNewAddress, watch, setValue]);

  const zipcode = watch('zipcode');

  useEffect(() => {
    if (zipcode?.length === 5) {
      const timeout = setTimeout(() => {
        onCallZipCode(zipcode);
      }, 300);

      return () => clearTimeout(timeout);
    }
  }, [zipcode]);

  const onSubmit = (values) => {
    const valuesWithCustomerCode = {
      ...values,
      customerCode: values.customerCode || parsedData?.addresses?.[0]?.customerCode || '',
      provinceId:
        typeof values.provinceId === 'object' ? values.provinceId.value : values.provinceId,
      districtId:
        typeof values.districtId === 'object' ? values.districtId.value : values.districtId,
      subDistrictId:
        typeof values.subDistrictId === 'object'
          ? values.subDistrictId.value
          : values.subDistrictId,
    };
    handleSubmitForm(valuesWithCustomerCode, onAddClaim);
  };
  return {
    control,
    getValues,
    setValue,
    watch,
    onCallZipCode,
    isLoadingZipCode,
    provinceOptions,
    districtOptions,
    subDistrictOptions,
    onChangeAddress,
    isCreateNewAddress,
    onSubmit,
    handleSubmit,
    isLoadingToSave,
  };
};
